/**
 * 学历类型分类占比组件
 */

import { useEffect, useState } from 'react';
import { message } from 'antd';
import $ from 'jquery';
import { UjoinParams, AddRequestHeaders } from '../../incs/FunHelper.js';
import RTypePercent from '../../components/RTypePercent.js';
import CNF from '../../incs/Config.js';

const UserUDEBC = (props) => {

    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    const getData = (orgInfoULID) => {
        const params = {
            'org_info_ulid': orgInfoULID,
        }
        $.ajax({
            url: `${CNF.sealApi}reports/user/udebc${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
            dataType: 'JSON',
        }).done(function (data) {
            if (data.res === 0) {
                setData(data.dat);
            }
        }).always(function () {
            setIsRefresh(false);
        });
    }

    useEffect(() => {
        if (props.orgInfosLists.length > 0 && isRefresh) {
            getData(props.orgInfosLists[0].key);
        }
    });

    return <RTypePercent id='antv-g2-id-UserUDEBC' data={data} title='' subtitle='' />
}

export default UserUDEBC;